import { render, staticRenderFns } from "./ProjectMain.vue?vue&type=template&id=635fc0c4&scoped=true&"
import script from "./ProjectMain.vue?vue&type=script&lang=js&"
export * from "./ProjectMain.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMain.vue?vue&type=style&index=0&id=635fc0c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635fc0c4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635fc0c4')) {
      api.createRecord('635fc0c4', component.options)
    } else {
      api.reload('635fc0c4', component.options)
    }
    module.hot.accept("./ProjectMain.vue?vue&type=template&id=635fc0c4&scoped=true&", function () {
      api.rerender('635fc0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/ProjectMain.vue"
export default component.exports